// BudgetDetails.jsx
import { AddCall as AddCallIcon, Check as CheckIcon, ContentCopy as ContentCopyIcon, Done as DoneIcon, Edit as EditIcon, ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon, PersonOutline as PersonOutlineIcon } from "@mui/icons-material";
import {
	Box,
	Card,
	Collapse,
	FormControl,
	Grid,
	IconButton,
	MenuItem,
	Select,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	TextField,
	Typography
} from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { getBudgetDetails, saveBudgetCallback, updateBudget } from "../../services/budgetService";
import { getCallStatusOptions } from "../../services/callCenterService";
import SidebarPhoneForm from "../phone/SidebarPhoneForm";

const BudgetDetails = ({ budget }) => {
	const [budgetInfo, setBudgetInfo] = useState({ details: [], retornos: [] });
	const [observacoes, setObservacoes] = useState('')
	const [selectedStatus, setSelectedStatus] = useState(0)
	const [selectedMotivoCancelamento, setSelectedMotivoCancelamento] = useState(0)
	
	const [statusOptions, setStatusOptions] = useState([]);
	const [motivoCancelamentoOptions, setMotivoCancelamentoOptions] = useState([]);
	
	const fetchOptions = async () => {
		const options = await getCallStatusOptions(3);
		const cancelamentoOptions = await getCallStatusOptions(5);
		setStatusOptions(options);
		setMotivoCancelamentoOptions(cancelamentoOptions)
	};

	const fetchData = async () => {
		const data = await getBudgetDetails(budget.id);
		setBudgetInfo(data);
		setObservacoes(data.observacoes)
		setSelectedStatus(data.id_status || 0)
		setSelectedMotivoCancelamento(data.id_motivo_cancelamento || 0)
	};

	useEffect(() => {
		if (!budget) return;
		fetchData();
		fetchOptions();
	}, [budget]);

	const formatPrice = (price) =>
		new Intl.NumberFormat("pt-BR", {
		style: "currency",
		currency: "BRL",
		}).format(price);

	const tableCellStyle = { textAlign: "center" };

	const styleByStatus = {
		Enviado: { color: "#37B24D" },
	};

	const infoCardStyle = {
		flex: "1 1 200px",
		backgroundColor: "#fff",
		border: "1px solid #eee",
		borderRadius: 2,
		p: "6px 12px",
		boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
		margin: "6px 2px"
	};

	const labelStyle = {
		textTransform: "uppercase",
		fontWeight: 500,
		letterSpacing: "0.05em",
		color: "#6b7280",
	};

	const infoDetailStyle = {
		flex: "1",
		backgroundColor: "#fff",
		border: "1px solid #eee",
		borderRadius: 2,
		p: "6px 12px",
		boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
		margin: "6px 0px"
	};

	const labelDetailStyle = {
		textTransform: "uppercase",
		fontWeight: 500,
		letterSpacing: "0.05em",
		color: "#6b7280",
	};

	const boxDetailStyle = {
		marginBottom: "40px"
	};

	const [editarOrcamento, setEditarOrcamento] = useState(false)

	const handleEditOrcamento = () => {
		setEditarOrcamento(true)
	}

	const handleSubmitBudgetUpdate = async () => {
		if(budgetInfo.observacoes !== observacoes || budgetInfo.id_status !== selectedStatus){	
			const budgetObj = {
				budget_id: budgetInfo.budget_id, 
				observacoes: observacoes,
				id_status: selectedStatus,
				id_motivo_cancelamento: selectedMotivoCancelamento || null
			}
			await updateBudget(budgetObj)
			fetchData()
		}
		setEditarOrcamento(false)
	}

	const iconButtonStyle = {
		display: "flex",
    	alignItems: "center",
		gap: "5px",
		"&:hover": {
			cursor: "pointer",
			opacity: '0.8'
		}
	}

	const [openDrawer, setOpenDrawer] = useState(false);
	const toggleDrawer = () => setOpenDrawer((prev) => !prev);

	const submitPhoneForm = async (formData) => {
		const [day, month, year] = formData.dtRetorno.split('/');
		const dt_retorno = new Date(Number(year), Number(month) - 1, Number(day));

		const callbackObj = {
			budget_id: budget.id,
			dt_retorno,
			midia: formData.selectedMidia
		}

		const budgetObj = {
			observacoes: formData.observacoes,
			id_status: formData.selectedStatus,
			id_motivo_cancelamento: formData.selectedMotivoCancelamento
		}

		const data = {
			budget_id:	budget.id,
			budget_type: 1,
			register_type: 'budget',
			callbackObj,
			newBudgetData: budgetObj
		}

		const res = await saveBudgetCallback(data)
		fetchData()
	}

  	const [open, setOpen] = useState(false);

	const handleCopy = async () => {
		const link = `https://pay.costao.com.br/orcamentos/${budgetInfo.hash}`;
		try {
			navigator.clipboard.writeText(link)
			.then(() => console.log("Texto copiado!"))
			.catch(err => console.error("Erro ao copiar:", err));
		} catch (err) {
			console.error("Falha ao copiar:", err);
		}
	};

	return (
		<Card id="card-details">
            <SidebarPhoneForm open={openDrawer} onClose={toggleDrawer} handleSubmit={submitPhoneForm} budgetInfo={budgetInfo} motivoCancelamentoOptions={motivoCancelamentoOptions} statusOptions={statusOptions}/>
            {/* {
              !openDrawer && <SidebarPhoneFab onClick={toggleDrawer} />
            } */}
			<Box sx={{ p: 3, minWidth: 1050, backgroundColor: "#f9fafb", borderBottom: "1px solid #eee" }}>
				<Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: "space-between", gap: '15px', mb: 2}}>
					<Typography variant="h2" sx={{ fontWeight: 600, display: "flex", alignItems: "center", gap: "10px"}}>
						Detalhes do Orçamento
						{
							editarOrcamento ? (
								<DoneIcon
									sx={{ ...iconButtonStyle, fontSize: '24px', color: 'green' }}
									onClick={handleSubmitBudgetUpdate}
								/>
							) : (
								<EditIcon
									sx={{
										...iconButtonStyle,
										fontSize: '24px',
										color: openDrawer ? 'grey' : 'inherit',
										pointerEvents: openDrawer ? 'none' : 'auto',
										opacity: openDrawer ? 0.5 : 1,
									}}
									onClick={!openDrawer ? handleEditOrcamento : undefined}
								/>
							)
						}
					</Typography>
					<Typography
						variant="h4"
						sx={{
							...iconButtonStyle,
							color: editarOrcamento ? 'grey' : 'green',
							pointerEvents: editarOrcamento ? 'none' : 'auto',
							opacity: editarOrcamento ? 0.5 : 1,
						}}
						onClick={!editarOrcamento ? toggleDrawer : undefined}
					>
						<AddCallIcon sx={{ fontSize: '32px' }} />
						Adicionar retorno
					</Typography>
				</Box>
				<Grid container columns={14} rowSpacing={'6px'} columnSpacing={'12px'} marginBottom={'6px'}>
					<Grid item size={6} sx={infoCardStyle}>
						<Typography variant="h5" sx={{...labelStyle, fontWeight: 600 }}>
							Cliente
						</Typography>
						<Typography variant="body1">{budget.client}</Typography>
					</Grid>
					<Grid item size={3} sx={infoCardStyle}>
						<Typography variant="caption" sx={labelStyle}>
							Operador
						</Typography>
						<Typography variant="body1">{budget.clerk}</Typography>
					</Grid>
					<Grid item size={3} sx={infoCardStyle}>
						<Typography variant="caption" sx={labelStyle}>
							Status
						</Typography>
						<Typography variant="body1" sx={{ ...styleByStatus[budget.status] }}>
							{budget.status}
						</Typography>
					</Grid>
					<Grid item size={3} sx={infoCardStyle}>
						<Typography variant="caption" sx={labelStyle}>
							Data de Envio
						</Typography>
						<Typography variant="body1">{budget.created_at}</Typography>
					</Grid>
					<Grid item size={3} sx={{...infoCardStyle, minWidth: 'max-content', maxWidth: 'fit-content'}}>
						<Typography variant="caption" sx={labelStyle}>
							Link Pagamento
						</Typography>
						<div style={{display: "flex"}}>
							<Typography variant="body1" sx={{flexGrow: 1, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", marginRight: '12px'}}>
								{budgetInfo.hash && `https://pay.costao.com.br/orcamentos/${budgetInfo.hash}`}
							</Typography>
							<ContentCopyIcon onClick={handleCopy}/>
						</div>
					</Grid>
				</Grid>
				{editarOrcamento ? 
					<Grid container size={12}>
						<Grid item size={6} sx={infoCardStyle}>
							<Typography variant="caption" sx={labelStyle}>
								Observações
							</Typography>
							<TextField
								fullWidth
								multiline
								value={observacoes}
								onChange={(e) => setObservacoes(e.target.value)}
							/>
						</Grid>
						<Grid item size={3} sx={infoCardStyle}>
							<Typography variant="caption" sx={labelStyle}>
								Motivo do acompanhamento
							</Typography>
							<FormControl fullWidth>
								<Select
									value={selectedStatus}
									onChange={e => setSelectedStatus(e.target.value)}
									sx={{
										fontWeight: !selectedStatus ? 600 : 500,
										fontFamily: 'Montserrat',
									}}
								>
									<MenuItem
										value={0}
										sx={{
											fontWeight: 600,
											fontFamily: 'Montserrat',
										}}
									>
										Selecione o motivo do acompanhamento
									</MenuItem>
									{statusOptions.map(item => (
										<MenuItem
											key={item.id}
											value={item.id}
											sx={{
												fontWeight: 500,
												fontFamily: 'Montserrat',
											}}
										>
											{item.ds_status}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item size={3} sx={infoCardStyle}>
							<Typography variant="caption" sx={labelStyle}>
								Motivo do cancelamento
							</Typography>
							<FormControl fullWidth>
								<Select
									value={selectedMotivoCancelamento}
									onChange={e => setSelectedMotivoCancelamento(e.target.value)}
									sx={{
										fontWeight: !selectedMotivoCancelamento ? 600 : 500,
										fontFamily: 'Montserrat',
									}}
								>
									<MenuItem
										value={0}
										sx={{
											fontWeight: 600,
											fontFamily: 'Montserrat',
										}}
									>
										Selecione o motivo do cancelamento
									</MenuItem>
									{motivoCancelamentoOptions.map(item => (
										<MenuItem
											key={item.id}
											value={item.id}
											sx={{
												fontWeight: 500,
												fontFamily: 'Montserrat',
											}}
										>
											{item.ds_status}
										</MenuItem>
									))}
								</Select>
							</FormControl>
							<Typography variant="caption" sx={{ color: "#6b7280", mt: 0.5, display: "block" }}>
								Não substitui o motivo do acompanhamento. Preencha só quando o orçamento for perdido/cancelado.
							</Typography>
						</Grid>
					</Grid>
					:
					<Grid container size={12}>
						<Grid item size={6} sx={infoCardStyle}>
							<Typography variant="caption" sx={labelStyle}>
								Observações
							</Typography>
							<Typography variant="body1">{budgetInfo.observacoes}</Typography>
						</Grid>
						<Grid item size={3} sx={infoCardStyle}>
							<Typography variant="caption" sx={labelStyle}>
								Motivo do acompanhamento
							</Typography>
							<Typography variant="body1">
								{budgetInfo.ds_status || "—"}
							</Typography>
						</Grid>
						<Grid item size={3} sx={infoCardStyle}>
							<Typography variant="caption" sx={labelStyle}>
								Motivo do cancelamento
							</Typography>
							<Typography variant="body1" sx={{ color: budgetInfo.ds_motivo_cancelamento ? "#CF142B" : "inherit", fontWeight: budgetInfo.ds_motivo_cancelamento ? 600 : 400 }}>
								{budgetInfo.ds_motivo_cancelamento || "—"}
							</Typography>
							{budgetInfo.ds_motivo_cancelamento && (
								<Typography variant="caption" sx={{ color: "#6b7280", display: "block", mt: 0.5 }}>
									Status efetivo: Cancelado. O motivo do acompanhamento acima é mantido como histórico.
								</Typography>
							)}
						</Grid>
					</Grid>			
				}
				{budgetInfo.retornos.length > 0 && (
					<Box>
						<Grid container>
							<Grid item size={12} sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
								<Typography variant="h4" sx={{ fontWeight: 500, margin: 0 }}>
									Lista de Retornos
								</Typography>
								{budgetInfo.retornos.length > 1 && (
									<IconButton onClick={() => setOpen(prev => !prev)}>
										{open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
									</IconButton>
								)}
							</Grid>
						</Grid>
						<Grid container key={budgetInfo.retornos[0].id_retorno}>
							<Grid item size={3} sx={infoCardStyle}>
								<Typography variant="caption" sx={labelStyle}>Mídia</Typography>
								<Typography variant="body1">{budgetInfo.retornos[0].midia}</Typography>
							</Grid>
							<Grid item size={3} sx={infoCardStyle}>
								<Typography variant="caption" sx={labelStyle}>Data de Retorno</Typography>
								<Typography variant="body1">{budgetInfo.retornos[0].dt_retorno}</Typography>
							</Grid>
							<Grid item size={6}>
							</Grid>
						</Grid>

						{budgetInfo.retornos.length > 1 && (
							<Grid container>
								<Grid item size={12}>
									<Collapse in={open}>
										{budgetInfo.retornos.slice(1).map(retorno => (
										<Grid container key={retorno.id_retorno}>
											<Grid item size={3} sx={infoCardStyle}>
											<Typography variant="caption" sx={labelStyle}>Mídia</Typography>
											<Typography variant="body1">{retorno.midia}</Typography>
											</Grid>
											<Grid item size={3} sx={infoCardStyle}>
											<Typography variant="caption" sx={labelStyle}>Data de Retorno</Typography>
											<Typography variant="body1">{retorno.dt_retorno}</Typography>
											</Grid>
											<Grid item size={6}></Grid>
										</Grid>
										))}
									</Collapse>
								</Grid>
							</Grid>
						)}
					</Box>
					)}
			</Box>
			<Box sx={{ p: 3, minWidth: 1050 }}>
				<Typography variant="h4" gutterBottom sx={{ fontWeight: 500 }}>
					Detalhes das Diárias
				</Typography>
				{budgetInfo.details.map((d) => (
					<Box key={d.id} sx={boxDetailStyle}>
						<Box
							sx={{
								display: "flex",
								flexWrap: "wrap",
								gap: 2,
							}}
						>
							<Box sx={infoDetailStyle}>
								<Typography variant="caption" sx={labelDetailStyle}>
									Check-in
								</Typography>
								<Typography variant="body1">{d.check_in}</Typography>
							</Box>
							<Box sx={infoDetailStyle}>
								<Typography variant="caption" sx={labelDetailStyle}>
									Check-out
								</Typography>
								<Typography variant="body1">{d.check_out}</Typography>
							</Box>
							<Box sx={infoDetailStyle}>
								<Typography variant="caption" sx={labelDetailStyle}>
									Adultos
								</Typography>
								<Typography variant="body1" sx={{ display: "flex", alignItems: "center" }}>
									<PersonOutlineIcon sx={{ pr: 0.5 }} fontSize="small" />
									{d.adults_quantity}
								</Typography>
							</Box>
							<Box sx={infoDetailStyle}>
								<Typography variant="caption" sx={labelDetailStyle}>
									Cri. CHD2
								</Typography>
								<Typography variant="body1" sx={{ display: "flex", alignItems: "center" }}>
									<PersonOutlineIcon sx={{ pr: 0.5 }} fontSize="small" />
									{d.children_quantity}
								</Typography>
							</Box>
							<Box sx={infoDetailStyle}>
								<Typography variant="caption" sx={labelDetailStyle}>
									Cri. CHD1
								</Typography>
								<Typography variant="body1" sx={{ display: "flex", alignItems: "center" }}>
									<PersonOutlineIcon sx={{ pr: 0.5 }} fontSize="small" />
									{d.babies_quantity}
								</Typography>
							</Box>
						</Box>
						<Table size="small">
							<TableHead>
								<TableRow sx={{ backgroundColor: "#f3f4f6" }}>
									<TableCell sx={tableCellStyle}>Acomodação</TableCell>
									<TableCell sx={tableCellStyle}>Preço</TableCell>
									<TableCell sx={tableCellStyle}>Indisponível</TableCell>
								</TableRow>
							</TableHead>
							{d.accommodations.map((uh) => (
								<TableBody>
									<TableRow key={d.id} hover>
										<TableCell sx={tableCellStyle}>{uh.uh_type}</TableCell>
										<TableCell sx={tableCellStyle}>{formatPrice(uh.price)}</TableCell>
										<TableCell sx={tableCellStyle}>
											{uh.flg_nao_disponivel ? <CheckIcon sx={{ fill: "black" }} /> : ""}
										</TableCell>
									</TableRow>
								</TableBody>
							))}
						</Table>
					</Box>
				))}
			</Box>
		</Card>
	);
};

BudgetDetails.propTypes = {
	budget: PropTypes.object.isRequired,
};

export default BudgetDetails;
